import { useEffect, useState } from "react";
import { useSidebar } from "../useSidebarProvider";
import { useDispatch, useSelector } from "react-redux";
import { StoreState } from "../../redux/storeState/storeState";
import actionIcon from "../../assets/images/actionsCircle.svg";
import * as contentActions from "../../redux/content/ContentActions";
import moment from "moment";
import tickIcon from "../../assets/images/contentTickIcon.svg";
import searchIcon from "../../assets/images/search-icon.svg";
import CompanyLogs from "../company/companyOverview/CompanyLogs";
import Table from "./table/Table";
import HelpSection from "./components/HelpSection";
import copyIcon from "../../../src/assets/images/copyIcon.svg";
function Content() {
  const { collapsed } = useSidebar();
  const [logSearchText, setlogSearchText] = useState("");
  const [slectedLable, setslectedLable] = useState("Last 30 Days");
  const [selectedValue, setselectedValue] = useState("Last30Days");
  const [closeSearchBarIfValue, setCloseSearchBarIfValue] = useState(true);
  // eslint-disable-next-line
  const [selectedOption, setSelectedOption] = useState("terms");
  const [searchText, setSearchText] = useState("");
  const [tableData, setTableData] = useState([{}]);
  const [logsLoading, setLogsLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(false);
  const [openNewPageModal, setOpenNewPageModal] = useState(false);
  const [selectedSection, setSelectedSection] = useState("");

  const [size, setsize] = useState(10);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  const [selectedDate, setSelectedDate] = useState({
    startDate: "",
    endDate: "",
  });
  const [contentLogs, setContentLogs] = useState([]);

  let options = [
    { lable: "Today", value: "Today" },
    { lable: "Yesterday", value: "Yesterday" },
    { lable: "This Week", value: "ThisWeek" },
    { lable: "Last Week", value: "LastWeek" },
    { lable: "Last 7 Days", value: "Last7Days" },
    { lable: "This Month", value: "ThisMonth" },
    { lable: "Last Month", value: "LastMonth" },
    { lable: "Last 30 Days", value: "Last30Days" },
    { lable: "Custom Range", value: "CustomRange" },
  ];
  const { totalCount, content, limit, pageNo, logs, logsTotal, selectedModule } = useSelector((state: StoreState) => ({
    totalCount: state?.content?.total,
    pageNo: state?.content?.page,
    limit: state?.content?.size,
    content: state.content.content,
    logs: state.content.contentLogs,
    logsTotal: state.content.contentLogsCount,
    selectedModule: state.content.selectedModule,
  }));
  const [listItems, setListItems] = useState([
    {
      label: "Terms & Conditions",
      isSelected: selectedModule === "terms" ? true : false,
      value: "terms",
    },
    {
      label: "Privacy Policy",
      isSelected: selectedModule === "privacy" ? true : false,
      value: "privacy",
    },
    {
      label: "Help Center",
      isSelected: selectedModule === "help" ? true : false,
      value: "help",
    },
  ]);

  const handleSearchLogs = (() => {
    let timeoutId: NodeJS.Timeout | undefined;
    return (searchString: any) => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        dispatch(
          contentActions.getAllContentLogs({
            limit: size,
            searchName: searchString,
            type: selectedItem?.value,
          })
        );
        if (searchString !== "") {
          setCloseSearchBarIfValue(false);
        } else {
          setCloseSearchBarIfValue(true);
        }
      }, 200);
    };
  })();

  const resetSearchingHandler = () => {
    dispatch(
      contentActions.getAllContentLogs({
        searchName: "",
        limit: size,
        type: selectedItem?.value,
      })
    );
  };
  const LoadMoreLogs = () => {
    dispatch(
      contentActions.getAllContentLogs({
        searchName: logSearchText,
        limit: +size + 10,
        type: selectedItem?.value,
      })
    ).then(() => {
      setLogsLoading(true);
    });
  };

  let headerData = [
    {
      label: "ID",
      id: "businessId",
    },
    {
      label: "CREATED",
      id: "createdDate",
    },
    {
      label: "PUBLISHED",
      id: "updatedDate",
    },
    {
      label: "ACTIVE",
      id: "active",
    },
  ];
  let helpHeaderData = [
    {
      label: "ID",
      id: "businessId",
    },
    {
      label: "PAGE",
      id: "pageName",
    },
    {
      label: "SECTION",
      id: "sectionName",
    },
    {
      label: "UPDATED",
      id: "updatedDate",
    },
    {
      label: "LINK",
      id: "link",
    },
  ];
  useEffect(() => {
    if (selectedSection?.length > 0 && selectedItem?.value === "help") {
      dispatch(
        contentActions.getAllContent({
          searchTerm: searchText,
          page: page,
          size: size,
          type: selectedItem?.value,
          sectionName: selectedSection,
        })
      );
    } else {
      dispatch(
        contentActions.getAllContent({
          searchTerm: searchText,
          page: page,
          size: size,
          type: selectedItem?.value,
        })
      );
    }

    // eslint-disable-next-line
  }, [selectedOption, page, size, selectedSection]);

  useEffect(() => {
    let refactoredData = content?.map((item: any) => {
      return {
        ...item,
        active: item?.isActive ? <img src={tickIcon} alt="tick-icon" /> : "",
        updatedDate: item?.isActive ? moment(item?.updated_at).format("DD MMM YYYY, HH:mm") : "",
        createdDate: moment(item?.created_at).format("DD MMM YYYY, HH:mm"),
        pageName: item?.helpContent?.pageName,
        sectionName: item?.helpContent?.sectionName,
        link: <img src={copyIcon} alt="copy" style={{ width: "20px", height: "20px" }} />,
        // isDeleted: item?.helpContent?.isDeleted,
      };
    });
    // let finalData = selectedItem?.value === "help" ? refactoredData?.filter((item: any) => !item?.isDeleted) : refactoredData;
    setTableData(refactoredData);

    // eslint-disable-next-line
  }, [content, selectedOption]);

  useEffect(() => {
    if (totalCount > 0 && total === 0) {
      setPage(pageNo);
      setTotal(totalCount);
      setsize(limit);
    } else if (contentLoading) {
      setPage(pageNo);
      setTotal(totalCount);
      setsize(limit);
    } else if (totalCount > 0) {
      setPage(pageNo);
      setTotal(totalCount);
      setsize(limit);
    }
    // eslint-disable-next-line
  }, [totalCount]);

  const handleSideItem = (item: any) => {
    let refactoredItems = listItems?.map((sub: any) => {
      if (sub?.label === item?.label) {
        return { ...sub, isSelected: true };
      } else return { ...sub, isSelected: false };
    });
    setListItems([...refactoredItems]);
    setContentLoading(true);
  };
  let selectedItem = listItems?.find((item: any) => item?.isSelected);
  const dispatch: any = useDispatch();
  useEffect(() => {
    if (contentLoading) {
      dispatch(
        contentActions.getAllContent({
          searchTerm: searchText,
          page: page,
          size: size,
          type: selectedItem?.value,
        })
      ).then(() => {
        dispatch(
          contentActions.getAllContentLogs({
            searchName: logSearchText,
            limit: size,
            type: selectedItem?.value,
          })
        );
        setContentLoading(false);
      });
    }

    // eslint-disable-next-line
  }, [selectedOption, contentLoading, contentLoading]);

  useEffect(() => {
    dispatch(
      contentActions.getAllContentLogs({
        searchName: logSearchText,
        limit: size,
        type: selectedItem?.value,
      })
    );
    // eslint-disable-next-line
  }, [logsLoading]);

  useEffect(() => {
    if (logs) {
      setContentLogs(logs);
    }
    // eslint-disable-next-line
  }, [logs, logsLoading, selectedOption]);

  const handleSearchTerms = (() => {
    let timeoutId: NodeJS.Timeout | undefined;
    return (searchString: any) => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        dispatch(
          contentActions.getAllContent({
            searchTerm: searchString,
            page: page,
            size: size,
            type: selectedItem?.value,
            sectionName: selectedSection,
          })
        );
      }, 200);
    };
  })();

  return (
    <div className="h-100" style={{ background: "rgb(242, 243, 248)" }}>
      <div className="company-wrap row m-0 pb-2" style={{ paddingLeft: !collapsed ? "17.8rem" : "3.5rem ", overflow: "hidden" }}>
        <div className="col-lg-3  col-md-12" style={{ minHeight: "90vh", position: "relative", bottom: 0, borderRadius: "5.46px" }}>
          <div className="side-company-info p-3 pr-3 h-100 bg-white ">
            <div className="content-actions-wrap ml-auto">
              <span>
                <img src={actionIcon} alt="actions" />
                <img src={actionIcon} alt="actions" />
                <img src={actionIcon} alt="actions" />
              </span>
            </div>
            <div className={`d-flex pt-2 content-side-wrapper flex-column`}>
              <hr style={{ width: "100%", background: "#E1E3EA" }} />

              {listItems?.map((item: any,index:number) => {
                return (
                  <div key={index} onClick={() => handleSideItem(item)} className={`${item?.isSelected ? "active" : ""}`}>
                    <span>{item?.label}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className=" col-lg-6 col-md-12 " style={{ height: "100%" }}>
          <div className="content-main-wrapper">
            <p className="title-main py-2 ">{selectedItem?.label || ""}</p>
            <div className="bg-white mt-4 p-4 ">
              <div className={`${selectedItem?.value === "help" ? "d-flex align-items-center justify-content-center" : ""}`}>
                <div
                  className={`sites-search-wrap ${selectedItem?.value === "help" ? "mr-auto" : "ml-auto"} mt-3 mb-2`}
                  style={{ width: "230px", justifyContent: "start", gap: "0.4rem" }}
                >
                  <img src={searchIcon} alt="searchIcon" width={13} height={13} />
                  <input
                    type="text"
                    placeholder="Search"
                    value={searchText}
                    onChange={(e: any) => {
                      setSearchText(e.target.value);
                      handleSearchTerms(e.target.value);
                    }}
                    className="sites-searchBar"
                  />
                </div>{" "}
                {selectedItem?.value === "help" ? (
                  <HelpSection
                    showModal={openNewPageModal}
                    setShowModal={setOpenNewPageModal}
                    selectedSection={selectedSection}
                    setSelectedSection={setSelectedSection}
                  />
                ) : null}
              </div>
              <Table
                headerData={selectedItem?.value === "help" ? helpHeaderData : headerData}
                tableData={tableData}
                handleSort={() => {}}
                handleArrowSortClick={() => {}}
                selectedHeader={""}
                isPagination={true}
                page={page}
                size={size}
                total={total}
                setPage={setPage}
                setSize={setsize}
              />
            </div>
          </div>
        </div>
        <div className=" col-lg-3 col-md-12 pb-2 bg-white" style={{ height: "100%", marginTop: "4rem" }}>
          <CompanyLogs
            options={options}
            selectedValue={selectedValue}
            setselectedValue={setselectedValue}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            setslectedLable={setslectedLable}
            slectedLable={slectedLable}
            totalCount={logsTotal}
            companyLogs={contentLogs}
            searchValue={logSearchText}
            setsearchValue={setlogSearchText}
            handleSearchLogs={handleSearchLogs}
            resetSearchingHandler={resetSearchingHandler}
            closeSearchBarIfValue={closeSearchBarIfValue}
            setCloseSearchBarIfValue={setCloseSearchBarIfValue}
            limit={size}
            LoadMoreLogs={LoadMoreLogs}
            title={selectedItem?.value === "help" ? "Help Center" : "Terms & Conditions"}
            notificationSection={false}
            subscription={false}
            dateSection={false}
            logSection={true}
            selectedOption={selectedOption}
            invoiceData={[]}
            isContentModule={true}
          />
        </div>
      </div>
    </div>
  );
}

export default Content;
